/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const INVOICE_STATUS_PAID = 'paid'
export const INVOICE_STATUS_PENDING = 'pending'
export const INVOICE_STATUS_UNPAID = 'unpaid'

export const InvoiceStatusCodes = [
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_PENDING,
  INVOICE_STATUS_UNPAID
]
